import { createContext, FC, useContext, useEffect, useState } from "react";
import { iDataUser } from "../../interfaces/SuperAdmin/Pages/iDataUser";
import { SelectChangeEvent } from "@mui/material";
import { getAllUsers } from "../../api/broker";
import { toast } from "react-toastify";
import { UserControlContextProps } from "../../interfaces/SuperAdmin/ContextProps/iUserControl";

const UserControlContext = createContext<UserControlContextProps>(
  {} as UserControlContextProps
);

interface Props {
  children: React.ReactNode;
}

const UserControlProvider: FC<Props> = ({ children }) => {
  const [page, setPage] = useState(1); //Página actual
  const [search, setSearch] = useState(""); //Búsqueda en search bar
  const [version, setVersion] = useState("all"); //Filtro de versiones

  const [users, setUsers] = useState<iDataUser[]>([]);
  const [totalUsers, setTotalUsers] = useState(0);

  const [isLoadingUsers, setIsLoadingUsers] = useState(true);

  //Funcion para traer usuarios
  const fetchUsers = async (search: string, version: string, page: number) => {
    setIsLoadingUsers(true);
    try {
      const userRes = await getAllUsers(version, page, search);

      if (userRes.data.statusCode === 200) {
        console.log(userRes);
        setUsers(userRes.data.body.usuarios);
        setTotalUsers(userRes.data.body.total);
      } else {
        toast.error("Error al obtener los usuarios");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error al obtener los usuarios");
    } finally {
      setIsLoadingUsers(false);
    }
  };

  useEffect(() => {
    fetchUsers(search, version, page);
  }, [page, search, version]);

  // Cambiar de página
  const changePage = (newValue: number) => setPage(newValue);

  // Cambiar de search text
  const changeSearch = (newValue: string) => {
    setPage(1);
    setSearch(newValue);
  };

  // Cambiar de version
  const changeVersion = (event: SelectChangeEvent) => {
    setPage(1);
    setVersion(event.target.value);
  };

  return (
    <UserControlContext.Provider
      value={{
        page,
        search,
        version,
        users,
        totalUsers,
        isLoadingUsers,
        changePage,
        changeSearch,
        changeVersion,
      }}
    >
      {children}
    </UserControlContext.Provider>
  );
};

const useUserControl = () => useContext(UserControlContext);

export { UserControlProvider, useUserControl };
